// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var ReactHtmlParser = require("react-html-parser").default;
var ReactHtmlParser$1 = require("react-html-parser");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Logic$ReactHooksTemplate = require("./Logic.res.js");
var Action$ReactHooksTemplate = require("./Action.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var Welcome$ReactHooksTemplate = require("./Welcome.res.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var RatingGroup$ReactHooksTemplate = require("./RatingGroup.res.js");
var SurveyTheme$ReactHooksTemplate = require("./surveyTheme.res.js");
var WelcomeForm$ReactHooksTemplate = require("./WelcomeForm.res.js");
var ThankYouForm$ReactHooksTemplate = require("./ThankYouForm.res.js");
var DateCondition$ReactHooksTemplate = require("./DateCondition.res.js");
var ListCondition$ReactHooksTemplate = require("./ListCondition.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var NumberCondition$ReactHooksTemplate = require("./NumberCondition.res.js");
var StringCondition$ReactHooksTemplate = require("./StringCondition.res.js");
var WelcomeFormBhima$ReactHooksTemplate = require("./WelcomeFormBhima.res.js");
var ThankYouFormBhima$ReactHooksTemplate = require("./ThankYouFormBhima.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var SurveyPageLanguageSlot$ReactHooksTemplate = require("./SurveyPageLanguageSlot.res.js");

var AnswerNotFound = /* @__PURE__ */Caml_exceptions.create("SurveyPreviewHtmlRenderer-ReactHooksTemplate.AnswerNotFound");

function domIdFortemplateIdentifiers(x) {
  switch (x) {
    case "Logo" :
        return "logo";
    case "Question" :
        return "question";
    case "Language" :
        return "language";
    case "ProgressBar" :
        return "progressBar";
    case "NextButtom" :
        return "nextButton";
    case "WelcomeButton" :
        return "welcomeButton";
    case "PreviousButton" :
        return "previousButton";
    case "Unknown" :
        return "";
    
  }
}

function convertDomIdToTemplateIdentifier(id) {
  if (id === "logo") {
    return "Logo";
  } else if (id === "language") {
    return "Language";
  } else if (id === "question") {
    return "Question";
  } else if (id === "progressBar") {
    return "ProgressBar";
  } else if (id === "nextButton") {
    return "NextButtom";
  } else if (id === "previousButton") {
    return "PreviousButton";
  } else {
    return "Unknown";
  }
}

function decodeNodeAttributes(json) {
  var id = Json_decode.optional((function (param) {
          return Json_decode.field("id", Json_decode.string, param);
        }), json);
  return convertDomIdToTemplateIdentifier(Belt_Option.getWithDefault(id, ""));
}

function decodeLogo(json) {
  return Json_decode.optional((function (param) {
                return Json_decode.field("url", Json_decode.string, param);
              }), json);
}

function calculateContainerHeight(type_) {
  switch (type_) {
    case "Page" :
        return "";
    case "Modal" :
        return "calc(100vh - 32px)";
    case "SideBar" :
        return "calc(100vh - 190px)";
    case "BuilderPhone" :
        return "100%";
    
  }
}

function calculateWelcomeContainerHeight(type_) {
  switch (type_) {
    case "Page" :
        return {
                height: "calc(100vh - 112px)"
              };
    case "Modal" :
        return {
                height: "calc(100vh - 144px)"
              };
    case "SideBar" :
        return {
                height: "calc(100vh - 270px)"
              };
    case "BuilderPhone" :
        return {
                height: "100%"
              };
    
  }
}

function isBuilderPhonePreview(type_) {
  if (type_ === "BuilderPhone") {
    return true;
  } else {
    return false;
  }
}

function getQuestionFromPage(page) {
  if (page === undefined) {
    return ;
  }
  switch (page.TAG) {
    case "QuestionPage" :
        return page._1;
    case "Welcome" :
    case "ThankYou" :
        return ;
    
  }
}

function SurveyPreviewHtmlRenderer(props) {
  var substitutionVariables = props.substitutionVariables;
  var verificationCode = props.verificationCode;
  var redirectionDelay = props.redirectionDelay;
  var surveyLanguages = props.surveyLanguages;
  var __languageSelected = props.languageSelected;
  var __showSubmitButton = props.showSubmitButton;
  var __showSkipButton = props.showSkipButton;
  var __showNextButton = props.showNextButton;
  var __showPreviousButton = props.showPreviousButton;
  var type_ = props.type_;
  var handleStart = props.handleStart;
  var onLanguageChange = props.onLanguageChange;
  var handleQuestionPreview = props.handleQuestionPreview;
  var onPrevButtonClick = props.onPrevButtonClick;
  var onNextButtonClick = props.onNextButtonClick;
  var client = props.client;
  var theme = props.theme;
  var logo = props.logo;
  var page = props.page;
  var survey = props.survey;
  var questions = props.questions;
  var showPreviousButton = __showPreviousButton !== undefined ? __showPreviousButton : true;
  var showNextButton = __showNextButton !== undefined ? __showNextButton : true;
  var showSkipButton = __showSkipButton !== undefined ? __showSkipButton : false;
  var showSubmitButton = __showSubmitButton !== undefined ? __showSubmitButton : true;
  var languageSelected = __languageSelected !== undefined ? __languageSelected : SurveyLanguage$ReactHooksTemplate.default;
  var selectorPosition = Survey$ReactHooksTemplate.languageSelectorPosition(survey);
  var showLanguageSelector;
  if (page !== undefined) {
    switch (page.TAG) {
      case "Welcome" :
          showLanguageSelector = true;
          break;
      case "QuestionPage" :
      case "ThankYou" :
          showLanguageSelector = false;
          break;
      
    }
  } else {
    showLanguageSelector = false;
  }
  var langSlot = function (expectedSlot, containerWidth) {
    if (showLanguageSelector) {
      return JsxRuntime.jsx(SurveyPageLanguageSlot$ReactHooksTemplate.make, {
                  position: selectorPosition,
                  expectedSlot: expectedSlot,
                  containerWidth: containerWidth,
                  surveyLanguages: surveyLanguages,
                  languageSelected: languageSelected,
                  onLanguageChange: onLanguageChange,
                  client: client
                });
    } else {
      return null;
    }
  };
  var isBhimaClient = OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "bhima";
  var questionContainerWidth = isBhimaClient ? "Wide" : "Narrow";
  var welcomeContainerWidth = isBhimaClient ? "Wide" : "Narrow";
  var logoElement = function (client, logo) {
    var match = SurveyTheme$ReactHooksTemplate.logoAlignment(theme);
    var logoAlignmentCss;
    if (match !== undefined) {
      switch (match) {
        case "end" :
            logoAlignmentCss = "justify-end items-end";
            break;
        case "start" :
            logoAlignmentCss = "justify-start items-start";
            break;
        default:
          logoAlignmentCss = "justify-center items-center";
      }
    } else {
      logoAlignmentCss = "justify-center items-center";
    }
    var match$1 = SurveyTheme$ReactHooksTemplate.logoSize(theme);
    var logoSize;
    if (match$1 !== undefined) {
      switch (match$1) {
        case "large" :
            logoSize = "h-24 small:h-16";
            break;
        case "medium" :
            logoSize = "h-16 small:h-12";
            break;
        default:
          logoSize = "h-12 small:h-10";
      }
    } else {
      logoSize = "h-12 small:h-10";
    }
    if (logo === undefined) {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
    var match$2 = OrganizationProfile$ReactHooksTemplate.name(client);
    if (match$2 === "bhima") {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("img", {
                        className: "h-100-px small:h-80-px",
                        src: logo
                      }),
                  className: "flex " + logoAlignmentCss
                });
    } else {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("img", {
                        className: logoSize,
                        src: logo
                      }),
                  className: "flex flex-col " + logoAlignmentCss
                });
    }
  };
  var logoWithLanguageSlots = function (containerWidth) {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  langSlot("AboveLogoSlot", containerWidth),
                  JsxRuntime.jsx("div", {
                        children: logoElement(client, logo),
                        id: "logo"
                      }),
                  langSlot("BelowLogoSlot", containerWidth)
                ]
              });
  };
  var isRatingGroupValid = function (maybeQuestionView) {
    if (maybeQuestionView === undefined) {
      return true;
    }
    if (maybeQuestionView.TAG !== "SingleQuestion") {
      return Belt_List.every(maybeQuestionView._0, (function (question) {
                    var mandatory = Question$ReactHooksTemplate.mandatory(question);
                    var ratingGroup = Question$ReactHooksTemplate.questionType(question);
                    if (ratingGroup.TAG === "RatingGroup") {
                      return RatingGroup$ReactHooksTemplate.isValidAnswerCount(mandatory, ratingGroup._0);
                    } else {
                      return true;
                    }
                  }));
    }
    var question = maybeQuestionView._0;
    if (question === undefined) {
      return true;
    }
    var mandatory = Question$ReactHooksTemplate.mandatory(question);
    var ratingGroup = Question$ReactHooksTemplate.questionType(question);
    if (ratingGroup.TAG === "RatingGroup") {
      return RatingGroup$ReactHooksTemplate.isValidAnswerCount(mandatory, ratingGroup._0);
    } else {
      return true;
    }
  };
  var nextButtonElement = function (enabled, bgColor, textColor, text) {
    if (enabled) {
      var match = OrganizationProfile$ReactHooksTemplate.name(client);
      if (match === "bhima") {
        return JsxRuntime.jsx("button", {
                    children: text,
                    className: " bg-" + bgColor + " shadow w-24 h-12 rounded text-" + textColor,
                    onClick: (function (param) {
                        Curry._1(onNextButtonClick, undefined);
                      })
                  });
      } else {
        return JsxRuntime.jsx("button", {
                    children: text,
                    className: " flex-grow h-48-px rounded-lg text-white\n                bg-opacity-100 ",
                    style: {
                      backgroundColor: SurveyTheme$ReactHooksTemplate.nextButtonColor(theme)
                    },
                    onClick: (function (param) {
                        Curry._1(onNextButtonClick, undefined);
                      })
                  });
      }
    }
    var match$1 = OrganizationProfile$ReactHooksTemplate.name(client);
    if (match$1 === "bhima") {
      return JsxRuntime.jsx("button", {
                  children: text,
                  className: " bg-" + bgColor + " border border-black w-24 h-12\n                            text-" + textColor + " rounded cursor-not-allowed"
                });
    } else {
      return JsxRuntime.jsx("button", {
                  children: text,
                  className: " flex-grow h-48-px\n              text-white rounded-lg cursor-not-allowed bg-opacity-25",
                  style: {
                    backgroundColor: SurveyTheme$ReactHooksTemplate.nextButtonColor(theme),
                    opacity: "0.25"
                  }
                });
    }
  };
  var previousButtonElement = function (enabled, borderColor) {
    if (!enabled) {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
    var match = OrganizationProfile$ReactHooksTemplate.name(client);
    if (match === "bhima") {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("button", {
                        children: SurveyLanguage$ReactHooksTemplate.message(languageSelected, "back"),
                        className: "border border-" + borderColor + " w-24 h-12 rounded text-" + borderColor,
                        onClick: (function (param) {
                            Curry._1(onPrevButtonClick, undefined);
                          })
                      }),
                  className: "pr-30-px"
                });
    } else {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("button", {
                        children: SurveyLanguage$ReactHooksTemplate.message(languageSelected, "back"),
                        className: "border border-herringsilver w-full h-48-px rounded-lg\n            text-" + borderColor + " border-solid bg-white bg-opacity-100 font-semibold\n            text-base leading-6 tracking-wide",
                        onClick: (function (param) {
                            Curry._1(onPrevButtonClick, undefined);
                          })
                      }),
                  className: "w-2/6 pr-16-px"
                });
    }
  };
  var questionElement = function (customerInfo, language, singlePageSurvey, question) {
    var ratingGroup = Question$ReactHooksTemplate.questionType(question);
    var question$1;
    switch (ratingGroup.TAG) {
      case "LongText" :
          var match = OrganizationProfile$ReactHooksTemplate.name(client);
          question$1 = match === "bhima" ? ({
                mandatory: question.mandatory,
                questionType: {
                  TAG: "LongText",
                  _0: LongText$ReactHooksTemplate.setRepresentation(ratingGroup._0, "BlackBackground")
                },
                id: question.id,
                position: question.position
              }) : question;
          break;
      case "RatingGroup" :
          var match$1 = OrganizationProfile$ReactHooksTemplate.name(client);
          question$1 = match$1 === "bhima" ? ({
                mandatory: question.mandatory,
                questionType: {
                  TAG: "RatingGroup",
                  _0: RatingGroup$ReactHooksTemplate.setRepresentationType(ratingGroup._0, "ColorCode")
                },
                id: question.id,
                position: question.position
              }) : question;
          break;
      case "MultipleSelect" :
      case "DropDown" :
          OrganizationProfile$ReactHooksTemplate.name(client);
          question$1 = question;
          break;
      default:
        question$1 = question;
    }
    var borderCss = isBuilderPhonePreview(type_) ? "p-2 border border-gray-200 rounded-md" : (
        singlePageSurvey ? "p-3 " : " p-8 border border-gray-400 rounded-lg"
      );
    return JsxRuntime.jsx("div", {
                children: Question$ReactHooksTemplate.toForm(Curry.__1(handleQuestionPreview), customerInfo, theme, language, client, question$1, borderCss, substitutionVariables)
              }, RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question$1)));
  };
  var buttonBgColor = function (nodeId) {
    if (OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "yesbank") {
      return "lochmara";
    } else if (OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "bhima") {
      return "yellowsea";
    } else {
      return "radicalred";
    }
  };
  var borderColor = function (nodeId) {
    if (OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "yesbank") {
      return "black";
    } else {
      OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "bhima";
      return "black";
    }
  };
  var textColor = function (nodeId) {
    if (OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "bhima" || OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() !== "yesbank") {
      return "black";
    } else {
      return "white";
    }
  };
  var progressBarElement = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("progress", {
                      className: "h-2 w-16",
                      max: "100",
                      value: "80"
                    }),
                className: "p-4"
              }),
          JsxRuntime.jsx("div", {
                children: "1 / 5",
                className: "text-white text-sm"
              })
        ],
        className: "flex items-center"
      });
  var transform = function (customerInfo, node, index) {
    var match = decodeNodeAttributes(node.attribs);
    switch (match) {
      case "Logo" :
          return logoWithLanguageSlots(questionContainerWidth);
      case "Question" :
          var questionView = getQuestionFromPage(page);
          var tmp;
          if (questionView !== undefined) {
            if (questionView.TAG === "SingleQuestion") {
              var question = questionView._0;
              tmp = question !== undefined ? questionElement(customerInfo, languageSelected, false, question) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
            } else {
              tmp = JsxRuntime.jsx("div", {
                    children: $$Array.of_list(Belt_List.map(questionView._0, (function (question) {
                                return questionElement(customerInfo, languageSelected, true, question);
                              }))),
                    className: " border border-gray-400 rounded-lg"
                  });
            }
          } else {
            tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
          }
          return JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: tmp,
                            className: "relative w-full"
                          }),
                      className: "w-full"
                    });
      case "ProgressBar" :
          return JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: Caml_option.some(progressBarElement)
                    });
      case "NextButtom" :
          return JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: Caml_option.some(showSubmitButton ? nextButtonElement(showNextButton && isRatingGroupValid(getQuestionFromPage(page)), buttonBgColor("NextButtom"), textColor("NextButtom"), SurveyLanguage$ReactHooksTemplate.message(languageSelected, "submit")) : (
                              showSkipButton ? nextButtonElement(true, buttonBgColor("NextButtom"), textColor("NextButtom"), SurveyLanguage$ReactHooksTemplate.message(languageSelected, "skip")) : nextButtonElement(showNextButton && isRatingGroupValid(getQuestionFromPage(page)), buttonBgColor("NextButtom"), textColor("NextButtom"), SurveyLanguage$ReactHooksTemplate.message(languageSelected, "next"))
                            ))
                    });
      case "Language" :
      case "WelcomeButton" :
          return JsxRuntime.jsx(JsxRuntime.Fragment, {});
      case "PreviousButton" :
          return JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: Caml_option.some(previousButtonElement(showPreviousButton, borderColor("PreviousButton")))
                    });
      case "Unknown" :
          return ReactHtmlParser$1.convertNodeToElement(node, index, (function (param, param$1) {
                        return transform(customerInfo, param, param$1);
                      }));
      
    }
  };
  var defaultWelcome = Welcome$ReactHooksTemplate.make("Your opinion matters!", "", "Take the survey", Image$ReactHooksTemplate.surveyWelcomeBg);
  var welcomePreviewItem = function (welcome, containerWidth) {
    var aboveButtonsSlot = langSlot("AboveButtonsSlot", containerWidth);
    var belowButtonsSlot = langSlot("BelowButtonsSlot", containerWidth);
    return Belt_Option.mapWithDefault(welcome, null, (function (param) {
                  return JsxRuntime.jsx("div", {
                              children: welcome !== undefined ? JsxRuntime.jsx(WelcomeForm$ReactHooksTemplate.make, {
                                      default: defaultWelcome,
                                      welcome: Caml_option.valFromOption(welcome),
                                      handleStart: handleStart,
                                      buttonBgColor: SurveyTheme$ReactHooksTemplate.nextButtonColor(theme),
                                      language: languageSelected,
                                      substitutionVariables: substitutionVariables,
                                      aboveButtonsSlot: Caml_option.some(aboveButtonsSlot),
                                      belowButtonsSlot: Caml_option.some(belowButtonsSlot)
                                    }) : JsxRuntime.jsx(WelcomeForm$ReactHooksTemplate.make, {
                                      default: defaultWelcome,
                                      welcome: defaultWelcome,
                                      handleStart: handleStart,
                                      buttonBgColor: SurveyTheme$ReactHooksTemplate.nextButtonColor(theme),
                                      language: languageSelected,
                                      substitutionVariables: substitutionVariables,
                                      aboveButtonsSlot: Caml_option.some(aboveButtonsSlot),
                                      belowButtonsSlot: Caml_option.some(belowButtonsSlot)
                                    }),
                              className: "h-full"
                            });
                }));
  };
  var welcomePreviewItemBhima = function (welcome, textColor, containerWidth) {
    var aboveButtonsSlot = langSlot("AboveButtonsSlot", containerWidth);
    var belowButtonsSlot = langSlot("BelowButtonsSlot", containerWidth);
    return Belt_Option.mapWithDefault(welcome, null, (function (param) {
                  return JsxRuntime.jsx("div", {
                              children: welcome !== undefined ? JsxRuntime.jsx(WelcomeFormBhima$ReactHooksTemplate.make, {
                                      default: defaultWelcome,
                                      welcome: Caml_option.valFromOption(welcome),
                                      textColor: textColor,
                                      buttonBgColor: SurveyTheme$ReactHooksTemplate.nextButtonColor(theme),
                                      handleStart: handleStart,
                                      language: languageSelected,
                                      substitutionVariables: substitutionVariables,
                                      aboveButtonsSlot: Caml_option.some(aboveButtonsSlot),
                                      belowButtonsSlot: Caml_option.some(belowButtonsSlot)
                                    }) : JsxRuntime.jsx(WelcomeFormBhima$ReactHooksTemplate.make, {
                                      default: defaultWelcome,
                                      welcome: defaultWelcome,
                                      textColor: textColor,
                                      buttonBgColor: SurveyTheme$ReactHooksTemplate.nextButtonColor(theme),
                                      handleStart: handleStart,
                                      language: languageSelected,
                                      substitutionVariables: substitutionVariables,
                                      aboveButtonsSlot: Caml_option.some(aboveButtonsSlot),
                                      belowButtonsSlot: Caml_option.some(belowButtonsSlot)
                                    }),
                              className: "h-full"
                            });
                }));
  };
  var defaultThankYou = ThankYou$ReactHooksTemplate.make("Thank you for taking the time to give your valuable feedback!");
  var sortLogicsByPriority = function (logics) {
    return List.sort((function (logic1, logic2) {
                  if (Logic$ReactHooksTemplate.priority(logic1) < Logic$ReactHooksTemplate.priority(logic2)) {
                    return -1;
                  } else if (Logic$ReactHooksTemplate.priority(logic1) > Logic$ReactHooksTemplate.priority(logic2)) {
                    return 1;
                  } else {
                    return 0;
                  }
                }), logics);
  };
  var logics = sortLogicsByPriority(Survey$ReactHooksTemplate.redirectionLogics(survey));
  console.log(Survey$ReactHooksTemplate.redirectionLogics(survey));
  var findTrueConditionLogic = Belt_List.getBy(logics, (function (logic) {
          return !Belt_List.some(Logic$ReactHooksTemplate.conditions(logic), (function (cond) {
                        var q = LogicCondition$ReactHooksTemplate.lhs(cond);
                        if (q.TAG === "Question") {
                          var q$1 = q._0;
                          var surveyQuestion = Belt_List.getBy(questions, (function (question) {
                                  return Question$ReactHooksTemplate.equals(q$1, question);
                                }));
                          if (surveyQuestion === undefined) {
                            return true;
                          }
                          if (!Question$ReactHooksTemplate.answered(surveyQuestion)) {
                            return true;
                          }
                          var n = LogicCondition$ReactHooksTemplate.conditionType(cond);
                          var tmp;
                          switch (n.TAG) {
                            case "NumberCondition" :
                                tmp = NumberCondition$ReactHooksTemplate.evaluate(NumberCondition$ReactHooksTemplate.setLhs(n._0, {
                                          TAG: "Question",
                                          _0: surveyQuestion
                                        }));
                                break;
                            case "StringCondition" :
                                tmp = StringCondition$ReactHooksTemplate.evaluate(StringCondition$ReactHooksTemplate.setLhs(n._0, {
                                          TAG: "Question",
                                          _0: surveyQuestion
                                        }));
                                break;
                            case "ListCondition" :
                                tmp = ListCondition$ReactHooksTemplate.evaluate(ListCondition$ReactHooksTemplate.setLhs(n._0, {
                                          TAG: "Question",
                                          _0: surveyQuestion
                                        }));
                                break;
                            case "DateCondition" :
                                tmp = DateCondition$ReactHooksTemplate.evaluate(DateCondition$ReactHooksTemplate.setLhs(n._0, {
                                          TAG: "Question",
                                          _0: surveyQuestion
                                        }));
                                break;
                            
                          }
                          return tmp === false;
                        }
                        var d = q._0;
                        var n$1 = LogicCondition$ReactHooksTemplate.conditionType(cond);
                        var tmp$1;
                        switch (n$1.TAG) {
                          case "NumberCondition" :
                              tmp$1 = NumberCondition$ReactHooksTemplate.evaluate(NumberCondition$ReactHooksTemplate.setLhs(n$1._0, {
                                        TAG: "DataField",
                                        _0: d
                                      }));
                              break;
                          case "StringCondition" :
                              tmp$1 = StringCondition$ReactHooksTemplate.evaluate(StringCondition$ReactHooksTemplate.setLhs(n$1._0, {
                                        TAG: "DataField",
                                        _0: d
                                      }));
                              break;
                          case "ListCondition" :
                              tmp$1 = ListCondition$ReactHooksTemplate.evaluate(ListCondition$ReactHooksTemplate.setLhs(n$1._0, {
                                        TAG: "DataField",
                                        _0: d
                                      }));
                              break;
                          case "DateCondition" :
                              tmp$1 = DateCondition$ReactHooksTemplate.evaluate(DateCondition$ReactHooksTemplate.setLhs(n$1._0, {
                                        TAG: "DataField",
                                        _0: d
                                      }));
                              break;
                          
                        }
                        return tmp$1 === false;
                      }));
        }));
  var findRedirectionUrl;
  if (findTrueConditionLogic !== undefined) {
    console.log("Logic Matched");
    var redirectionLogic = Belt_List.getBy(Logic$ReactHooksTemplate.actions(Caml_option.valFromOption(findTrueConditionLogic)), (function (action) {
            var match = action.actionType;
            if (match.TAG === "Redirection") {
              return true;
            } else {
              return false;
            }
          }));
    if (redirectionLogic !== undefined) {
      var redirectionUrl = Action$ReactHooksTemplate.actionType(redirectionLogic);
      if (redirectionUrl.TAG === "Redirection") {
        var redirectionUrl$1 = redirectionUrl._0;
        console.log("Some  redirection url");
        console.log(redirectionUrl$1);
        findRedirectionUrl = redirectionUrl$1;
      } else {
        findRedirectionUrl = undefined;
      }
    } else {
      findRedirectionUrl = undefined;
    }
  } else {
    console.log("No logic Matched");
    findRedirectionUrl = undefined;
  }
  var thankYouPreviewItem = function (thankYou) {
    var verificationCodeToShow = findRedirectionUrl !== undefined ? verificationCode : undefined;
    return JsxRuntime.jsx(ThankYouForm$ReactHooksTemplate.make, {
                thankYou: Belt_Option.getWithDefault(thankYou, defaultThankYou),
                language: languageSelected,
                redirectionUrl: findRedirectionUrl,
                redirectionDelay: redirectionDelay,
                redirectionType: Survey$ReactHooksTemplate.redirectionType(survey),
                redirectionButtonText: Survey$ReactHooksTemplate.redirectionButtonText(survey),
                redirectionDescription: Survey$ReactHooksTemplate.redirectionDescription(survey),
                verificationCode: verificationCodeToShow,
                theme: theme,
                substitutionVariables: substitutionVariables
              });
  };
  var thankYouPreviewItemBhima = function (thankYou, textColor) {
    return JsxRuntime.jsx(ThankYouFormBhima$ReactHooksTemplate.make, {
                thankYou: Belt_Option.getWithDefault(thankYou, defaultThankYou),
                textColor: textColor,
                language: languageSelected,
                redirectionUrl: findRedirectionUrl,
                substitutionVariables: substitutionVariables
              });
  };
  var tmp;
  if (OrganizationProfile$ReactHooksTemplate.name(client) === OrganizationProfile$ReactHooksTemplate.emptyString) {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                text: "Loading Survey.."
              }),
          className: isBuilderPhonePreview(type_) ? "h-full w-full animated fadeIn" : "h-screen w-full animated fadeIn"
        });
  } else {
    var tmp$1;
    if (page !== undefined) {
      switch (page.TAG) {
        case "Welcome" :
            var welcome = page._0;
            tmp$1 = isBuilderPhonePreview(type_) ? JsxRuntime.jsxs("div", {
                    children: [
                      langSlot("FixedSlot", welcomeContainerWidth),
                      langSlot("TopBarSlot", welcomeContainerWidth),
                      JsxRuntime.jsx("div", {
                            children: logoWithLanguageSlots(welcomeContainerWidth),
                            className: "sb-builder-welcome-logo"
                          }),
                      JsxRuntime.jsx("div", {
                            children: welcomePreviewItem(welcome, welcomeContainerWidth),
                            className: "sb-builder-welcome-body"
                          })
                    ],
                    className: "sb-builder-preview-page sb-builder-preview-welcome flex flex-col h-full min-h-0 overflow-hidden"
                  }) : (
                OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "yesbank" ? JsxRuntime.jsx(JsxRuntime.Fragment, {
                        children: Caml_option.some(JsxRuntime.jsxs("div", {
                                  children: [
                                    langSlot("FixedSlot", welcomeContainerWidth),
                                    langSlot("TopBarSlot", welcomeContainerWidth),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: logoWithLanguageSlots(welcomeContainerWidth),
                                                  className: "h-84-px small:h-64-px py-16-px shrink-0"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: welcomePreviewItem(welcome, welcomeContainerWidth),
                                                  className: "flex-1 flex flex-col justify-center"
                                                })
                                          ],
                                          className: "max-w-440-px mx-auto px-40-px small:px-20-px small:pb-80-px flex-1 flex flex-col"
                                        })
                                  ],
                                  className: "min-h-screen flex flex-col"
                                }))
                      }) : (
                    OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "bhima" ? JsxRuntime.jsx(JsxRuntime.Fragment, {
                            children: Caml_option.some(JsxRuntime.jsxs("div", {
                                      children: [
                                        langSlot("FixedSlot", welcomeContainerWidth),
                                        langSlot("TopBarSlot", welcomeContainerWidth),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: logoWithLanguageSlots(welcomeContainerWidth),
                                                      className: "shrink-0"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: welcomePreviewItemBhima(welcome, textColor({
                                                                TAG: "Welcome",
                                                                _0: welcome
                                                              }), welcomeContainerWidth),
                                                      className: "flex-1 flex flex-col justify-center"
                                                    })
                                              ],
                                              className: "max-w-840-px mx-auto px-60-px flex-1 flex flex-col"
                                            })
                                      ],
                                      className: "min-h-screen flex flex-col"
                                    }))
                          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                            children: Caml_option.some(JsxRuntime.jsxs("div", {
                                      children: [
                                        langSlot("FixedSlot", welcomeContainerWidth),
                                        langSlot("TopBarSlot", welcomeContainerWidth),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: logoWithLanguageSlots(welcomeContainerWidth),
                                                      className: "h-84-px small:h-64-px py-16-px shrink-0"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: welcomePreviewItem(welcome, welcomeContainerWidth),
                                                      className: "flex-1 flex flex-col justify-center"
                                                    })
                                              ],
                                              className: "max-w-440-px mx-auto px-40-px small:px-20-px small:pb-80-px flex-1 flex flex-col"
                                            })
                                      ],
                                      className: "min-h-screen flex flex-col"
                                    }))
                          })
                  )
              );
            break;
        case "QuestionPage" :
            var customerInfo = page._2;
            var templates = page._0;
            var template = OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "bhima" ? templates.bhima : (OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase() === "yesbank", templates.default);
            tmp$1 = isBuilderPhonePreview(type_) ? JsxRuntime.jsxs("div", {
                    children: [
                      langSlot("FixedSlot", questionContainerWidth),
                      langSlot("TopBarSlot", questionContainerWidth),
                      JsxRuntime.jsx("div", {
                            children: logoWithLanguageSlots(questionContainerWidth),
                            className: "shrink-0 px-3 pt-3 pb-2 text-center"
                          }),
                      JsxRuntime.jsx("div", {
                            children: ReactHtmlParser(template, {
                                  transform: (function (param, param$1) {
                                      return transform(customerInfo, param, param$1);
                                    })
                                }),
                            className: "flex-1 min-h-0 overflow-y-auto sb-builder-preview-question"
                          })
                    ],
                    className: "sb-builder-preview-page flex flex-col h-full min-h-0 overflow-hidden"
                  }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      langSlot("FixedSlot", questionContainerWidth),
                      langSlot("TopBarSlot", questionContainerWidth),
                      ReactHtmlParser(template, {
                            transform: (function (param, param$1) {
                                return transform(customerInfo, param, param$1);
                              })
                          })
                    ]
                  });
            break;
        case "ThankYou" :
            var thankYou = page._0;
            if (isBuilderPhonePreview(type_)) {
              tmp$1 = JsxRuntime.jsxs("div", {
                    children: [
                      langSlot("FixedSlot", "Narrow"),
                      langSlot("TopBarSlot", "Narrow"),
                      JsxRuntime.jsx("div", {
                            children: logoWithLanguageSlots("Narrow"),
                            className: "sb-builder-welcome-logo"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              thankYouPreviewItem(thankYou),
                              langSlot("AboveButtonsSlot", "Narrow"),
                              langSlot("BelowButtonsSlot", "Narrow")
                            ],
                            className: "sb-builder-welcome-body"
                          })
                    ],
                    className: "sb-builder-preview-page sb-builder-preview-thankyou flex flex-col h-full min-h-0 overflow-hidden"
                  });
            } else {
              var clientName = OrganizationProfile$ReactHooksTemplate.name(client).toLowerCase();
              tmp$1 = clientName === "bhima" ? JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: Caml_option.some(JsxRuntime.jsxs("div", {
                                children: [
                                  langSlot("FixedSlot", "Wide"),
                                  langSlot("TopBarSlot", "Wide"),
                                  JsxRuntime.jsx("div", {
                                        children: logoWithLanguageSlots("Wide"),
                                        className: "pt-40-px w-full pb-20-px absolute"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          thankYouPreviewItemBhima(thankYou, textColor({
                                                    TAG: "ThankYou",
                                                    _0: thankYou
                                                  })),
                                          langSlot("AboveButtonsSlot", "Wide"),
                                          langSlot("BelowButtonsSlot", "Wide")
                                        ],
                                        className: "max-w-840-px mx-auto px-60-px"
                                      })
                                ],
                                className: "min-h-screen"
                              }))
                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: Caml_option.some(JsxRuntime.jsxs("div", {
                                children: [
                                  langSlot("FixedSlot", "Narrow"),
                                  langSlot("TopBarSlot", "Narrow"),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: logoWithLanguageSlots("Narrow"),
                                                className: "h-84-px small:h-64-px py-16-px"
                                              }),
                                          thankYouPreviewItem(thankYou),
                                          langSlot("AboveButtonsSlot", "Narrow"),
                                          langSlot("BelowButtonsSlot", "Narrow")
                                        ],
                                        className: "max-w-440-px mx-auto px-40-px small:px-20-px pt-32-px small:pt-0\n    small:pb-80-px"
                                      })
                                ],
                                className: "min-h-screen"
                              }))
                    });
            }
            break;
        
      }
    } else {
      tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {
          children: Caml_option.some(tmp$1)
        });
  }
  return JsxRuntime.jsx("div", {
              children: tmp,
              className: isBuilderPhonePreview(type_) ? "bg-white h-full overflow-hidden" : "bg-white",
              dir: SurveyLanguage$ReactHooksTemplate.name(languageSelected) === "Arabic" ? "rtl" : "",
              style: {
                color: SurveyTheme$ReactHooksTemplate.questionColor(theme),
                fontFamily: SurveyTheme$ReactHooksTemplate.font(theme),
                height: calculateContainerHeight(type_)
              }
            });
}

var make = SurveyPreviewHtmlRenderer;

exports.AnswerNotFound = AnswerNotFound;
exports.domIdFortemplateIdentifiers = domIdFortemplateIdentifiers;
exports.convertDomIdToTemplateIdentifier = convertDomIdToTemplateIdentifier;
exports.decodeNodeAttributes = decodeNodeAttributes;
exports.decodeLogo = decodeLogo;
exports.calculateContainerHeight = calculateContainerHeight;
exports.calculateWelcomeContainerHeight = calculateWelcomeContainerHeight;
exports.isBuilderPhonePreview = isBuilderPhonePreview;
exports.getQuestionFromPage = getQuestionFromPage;
exports.make = make;
/* react-html-parser Not a pure module */
